var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"message",attrs:{"data-testid":_vm.testid}},[_c('BranchLogo',{staticClass:"brand",attrs:{"branch":_vm.branch}}),(_vm.title)?_c('h1',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }